<mat-form-field [formGroup]="form" style="width:100%">
  <mat-select [placeholder]="item.label" 
    [required]="item.required"
    (selectionChange)="onChange($event)" 
    [formControlName]="item.name" >
    <mat-option *ngFor="let opt of item.options" [value]="opt.data">{{opt.label}}</mat-option>
  </mat-select>
</mat-form-field>
<!-- [value]="item.value" -->